<div *ngIf="entity?.id, else formTemplate">
  <div class="row wrapper border-bottom white-bg page-heading info-projeto">
    <div class="col-lg-10 title-projeto">
      <h2>Custos - Impacto orçamentário-financeiro</h2>
      <h3>Projeto</h3>
    </div>
    <div class="col-lg-2"></div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>


<ng-template #formTemplate>
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }} Impacto orçamentário-financeiro</h3>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()">
            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Item</label>
                <textarea id="title" class="form-control" formControlName="title" required maxlength="300"
                  rows="4"></textarea>
                <app-field-message [field]="fieldMessageRequired('title')"
                  [erros]="fieldErros('title')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Ano 1 (em R$)</label>
                <input type="text" id="year_1" class="form-control text-end" formControlName="year_1" maxlength="13"
                  (keyup)="maskCurrency($event, 'year_1')" />
                <app-field-message [field]="fieldMessageRequired('year_1')"
                  [erros]="fieldErros('year_1')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Ano 2 (em R$)</label>
                <input type="text" id="year_2" class="form-control text-end" formControlName="year_2" maxlength="13"
                  (keyup)="maskCurrency($event, 'year_2')" />
                <app-field-message [field]="fieldMessageRequired('year_2')"
                  [erros]="fieldErros('year_2')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Ano 3 (em R$)</label>
                <input type="text" id="year_3" class="form-control text-end" formControlName="year_3" maxlength="13"
                  (keyup)="maskCurrency($event, 'year_3')" />
                <app-field-message [field]="fieldMessageRequired('year_3')"
                  [erros]="fieldErros('year_3')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">
                  Metodologia utilizada
                  <i id="my-icon" class="fa fa-info-circle"
                    tooltip="Cite os paramêtros e referências utilizados para a estimativa apresentada"></i>
                </label>
                <textarea id="ds_method" class="form-control" formControlName="ds_method" required maxlength="3000"
                  rows="4"></textarea>
                <app-field-message [field]="fieldMessageRequired('ds_method')"
                  [erros]="fieldErros('ds_method')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button *ngIf="this.entity?.id && canSave" class="btn btn-danger m-r-xxl" (click)="confirmExcluir()"
                  type="button">Excluir</button>
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button *ngIf="canSave" class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
          <br>
          <app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
        </div>
      </div>
    </div>
  </div>
</ng-template>